import { IGetState, TCardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { cardsActionSetAction } from '../../../../../../../../../store/model/actions/cardsActionSetAction';
import { cardsUpdateAction } from '../../../../../../../../../store/model/cards/actions/cardsUpdateAction';
import { EQuickLookType } from '../../../components/Card/types';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { getCard } from '../../../../../../../../../store/model/selectors/getCard';
import { SegmentCardOptionStatusValue } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onQuickLookChange = (
    cardId: TCardId,
    openedQuickLook: EQuickLookType
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const { openedQuickLook: currentQuickLook } = getCard(getState(), cardId);
        let event;
        if (
            openedQuickLook === EQuickLookType.CHECKLISTS ||
            currentQuickLook === EQuickLookType.CHECKLISTS
        ) {
            event = segmentTrackAction(SegmentCardEvent.CARD_QUICK_LOOK_CHECKLISTS_CLICKED, {
                name: SegmentCardOptions.STATUS,
                value: openedQuickLook ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF
            });
        } else if (
            openedQuickLook === EQuickLookType.SUBCARDS ||
            currentQuickLook === EQuickLookType.SUBCARDS
        ) {
            event = segmentTrackAction(SegmentCardEvent.CARD_QUICK_LOOK_SUBCARDS_CLICKED, {
                name: SegmentCardOptions.STATUS,
                value: openedQuickLook ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF
            });
        } else if (
            openedQuickLook === EQuickLookType.ATTACHMENTS ||
            currentQuickLook === EQuickLookType.ATTACHMENTS
        ) {
            event = segmentTrackAction(SegmentCardEvent.CARD_QUICK_LOOK_ATTACHMENTS_CLICKED, {
                name: SegmentCardOptions.STATUS,
                value: openedQuickLook ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF
            });
        } else if (
            openedQuickLook === EQuickLookType.DESCRIPTION ||
            currentQuickLook === EQuickLookType.DESCRIPTION
        ) {
            event = segmentTrackAction(SegmentCardEvent.CARD_QUICK_LOOK_DESCRIPTION_CLICKED, {
                name: SegmentCardOptions.STATUS,
                value: openedQuickLook ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF
            });
        } else if (
            openedQuickLook === EQuickLookType.COMMENTS ||
            currentQuickLook === EQuickLookType.COMMENTS
        ) {
            event = segmentTrackAction(SegmentCardEvent.CARD_QUICK_LOOK_COMMENTS_CLICKED, {
                name: SegmentCardOptions.STATUS,
                value: openedQuickLook ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF
            });
        }
        if (event) dispatch(event);
        dispatch(cardsActionSetAction(cardsUpdateAction({ [cardId]: { openedQuickLook } })));
    };
};
